/** @deprecated Quarantined legacy (WEB-8861) — moved out of the Angular tree so the ReactTemplates.processedByColumn global survives Phase 6. Do not import in new code. */
'use strict';

import ProcessedBy from 'App/components/columns/ProcessedBy';
import openModal from 'App/services/Modal/Modal';
import { openEditAppointment } from 'Components/Modals/Appointment/EditAppointment';

ReactTemplates.processedByColumn = window.ReactCreateClass({
	UNSAFE_componentWillMount: function () {
		var t = Tools.$translate;

		this.lang = {
			title: t('processedby-title'),
			assign: t('default.assign'),
			assignShort: t('default.assign'),
			assignToUser: t('default.assignToUser'),
			updateUser: t('default.updateUser'),
			noactivities: t('processedbyNoActivities'),
			chooseUser: t('assign.chooseSeller'),
			activitiesAndAppointments: t('default.activitiesAndAppointments'),
			users: t('default.user'),
			handle: t('default.handle'),
			closeActivity: t('default.closeActivity'),
			addNotes: t('default.addNotes'),
			descriptionToSeller: t('assign.descriptionToSeller')
		};
	},
	openProcessedByModal: function (e) {
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();

		var props = this.props;

		if (!props.disabled) {
			var item = props.item;
			var contactId = null;

			if (item.contactId && props.options?.showContact) {
				contactId = item.contactId;
			}
			if (item.contact && item.contact.id) {
				contactId = item.contact.id;
			}

			openModal('AssignModal', {
				client: this.props.client,
				contactId: contactId,
				from: 'listLeads',
				formFields: item.fieldValues,
				formId: item.formId
			});
		}
	},
	openActivity: function (e) {
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();

		Tools.$upModal.open('editActivity', { id: this.props.client.processedBy.id });
	},
	openAppointment: function (e) {
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();
		var customerId = Tools.AppService.getCustomerId();

		openEditAppointment({ customerId: customerId, id: this.props.item.client.processedBy.id });
	},
	render: function () {
		var props = this.props;
		const { client, item } = props;
		var tools = Tools;

		if (!client) {
			return ReactTemplates.TOOLS.emptyTD('', this.props.theKey);
		}

		var user = null;
		if (client.processedBy) {
			user = client.processedBy.user;
		}

		if (user) {
			var classes = !client.processedBy ? 'assigned-info no-date' : 'assigned-info';
			var haveInactiveUser = !user.active;
			var processedByElement = null;

			if (client.processedBy) {
				var isOverDue = false;

				if (client.processedBy.entityType === 'Activity') {
					var date = moment(client.processedBy.date);

					if (!client.processedBy.time) {
						date.hours(23).minutes(59);
					} else {
						var timeParts = client.processedBy.time.split(':');
						date.hours(timeParts[0]).minutes(timeParts[1]);
					}

					if (moment().isAfter(date)) {
						isOverDue = true;
					}
				}

				processedByElement = (
					<div className={isOverDue && !haveInactiveUser ? 'text-red' : ''}>
						<i className="up-icon-activity" /> {moment(client.processedBy.date).format('L')}
					</div>
				);
			}

			return (
				<td
					key={this.props.theKey}
					data-test-id="processedby-column"
					onClick={this.openProcessedByModal}
					className={
						(haveInactiveUser ? 'column-assigned inactive-user' : 'column-assigned') +
						' ' +
						(this.props.className || '')
					}
				>
					<div className="assigned-wrap">
						{haveInactiveUser ? (
							<div className="inactive-user-icon-wrap">
								<i className="fa fa-user-times" aria-hidden="true" />
							</div>
						) : (
							<div>
								<ReactTemplates.TOOLS.avatar
									key={user.id}
									user={user}
									size={20}
									avatarService={tools.avatarService}
									style={{ marginTop: '2px' }}
								/>
							</div>
						)}
						<div className={classes}>
							<div className="user-name">{user.name}</div>
							{processedByElement}
						</div>
					</div>
				</td>
			);
		}

		const assignBtn = (
			<ProcessedBy
				formFields={item.fieldValues}
				formId={item.formId}
				client={this.props.item.client || client}
				disabled={!!props.disabled}
			/>
		);

		return (
			<td
				key={this.props.theKey}
				data-test-id="processedby-column"
				className={'column-assigned' + ' ' + (this.props.className || '')}
				onClick={this.openProcessedByModal}
			>
				{assignBtn}
			</td>
		);
	}
});
